import React, { Component } from 'react';
import { connect } from 'react-redux'
import { INTEGRATION, USER_STATE, TYPE_CALL, TYPE_DESIGN_CALL, DRAGGABLE_WINDOWS, ACTION_CALL_ACD, HANG_UP_SUBACTIONS, ASSISTED_TRANSFER } from '../../constants'
import { noVolume, volumeMedium, rateCallSvg, assistedTransfer, dtmfSVG, volume, mute, hold, resume, ivr, record, hangUp, moreOptions, hangUpLeaveMessage } from '../../Images/CallSpaceHeaderSVG';
import { callAction } from '../../redux/actions/A_reducer_call_acd';
import { messageToStateMachine } from '../../redux/actions/A_messages_to_SM';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import { SingletonSharedData } from '../../js/singletonSharedData';
import CallWindow from './CallComponents/CallWindow.jsx';
import RateCall from './CallComponents/RateCall.jsx';
import VolumeWindow from './Others/Volume.jsx';
import CallHeader from './CallComponents/CallHeader.jsx';
import { transferCallWindow, dtmfTonesWindow, markCallWindow, ongoingCallIvrWindow } from '../../js/draggableComponents';
import { insertWindow, removeWindow } from '../../redux/actions/A_draggable_windows_controller'
import { messageStartStopRecording, messageHangUp } from '../../js/helpers/helperMessages';
import ModalActions from '../../redux/actions/A_ongoing_call_ivr_modal';
import SingletonWebSocket from '../../js/Singletons/SingletonWebSocket';
import XFerToneB from '../../audios/XFerToneB.mp3'
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Singleton } from "../../js/Singleton";
import { volumeMicrophone,volumeSpeaker } from '../../redux/actions/A_volume';
import { Logger } from '../../js/helpers/Logger.js';
import CallHeaderPreview from './CallComponents/CallHeaderPreview';
import { updatePreviewRecord } from '../../redux/actions/A_preview';
class CallSpace extends Component {
  constructor(props) {
    super(props);
    this.sharedData = new SingletonSharedData();
    Logger.Info("[callspace][constructor] get volume speaker:" + this.sharedData.getVolumeSpeaker() + " microphone:" + this.sharedData.getVolumeMic() + "");
    this.state = {
      iconCall: null,
      dataCall: props.dataCall,
      extraDataCall: props.extraDataCall,
      currentState: props.currentState,
      volumeSpeaker: this.sharedData.getVolumeSpeaker(),
      volumeMicrophone: this.sharedData.getVolumeMic(),
      lastVolume: 50,
      barSize: 600,
      showingMoreOptions: false,
      marginRight: 70,
      marginLeft: 122,
      onTransferWindow: false,
      hangUpLeaveMessage: false,
      disableHp:false,
      dispositionListInformation:null,
      dispositionListError:null,
      dataIneffectiveCall:'',
      existData: false,
      setShowDataBySetting: false,
      renderButtons: [
        {
          idButton: "disposition",
          image: rateCallSvg,
          tooltip: "Disposition",
          active: false,
          enabledState: true,
          showed: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionDisposition(),
          hideAt: 590
        },
        {
          idButton: "leaveMessage",
          image: hangUpLeaveMessage,
          tooltip: "LeaveMessage",
          active: false,
          enabledState: false,
          showed: false,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionHangUpAndLeaveMessage(),
          hideAt: 590
        },
        {
          idButton: "transfer",
          image: assistedTransfer,
          tooltip: "Transfer",
          active: false,
          enabledState: true,
          showed: Boolean(parseInt( this.sharedData.getGeneralPermissions()[82], 10)),
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionTransfer(),
          hideAt: 530
        },
        {
          idButton: "dtmf",
          image: dtmfSVG,
          tooltip: "DTMF",
          active: false,
          showed: true,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionDTMF(),
          hideAt: 450
        },
        {
          idButton: "volume",
          image: volumeMedium,
          tooltip: "Volume",
          active: false,
          enabledState: true,
          showed: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionVolume(),
          hideAt: 0
        },
        {
          idButton: "mute",
          image: mute,
          tooltip: "Mute",
          active: false,
          showed: true,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionMute(),
          hideAt: 0
        },
        {
          idButton: "hold",
          image: hold,
          tooltip: "Hold",
          active: false,
          showed: false,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionPauseCall(),
          hideAt: 280
        },
        {
          idButton: "marks",
          image: resume,
          tooltip: "Mark",
          active: false,
          showed: true,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionMarkCall(),
          hideAt: 480
        },
        {
          idButton: "ivr",
          image: ivr,
          tooltip: "IVR",
          active: false,
          showed: false,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionIVR(),
          hideAt: 600
        },
        {
          idButton: "record",
          image: record,
          tooltip: "Record",
          active: false,
          showed: false,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.actionPauseRecord(),
          hideAt: 600
        }
      ],
      rightButtons: [
        {
          idButton: "hangUp",
          image: hangUp,
          tooltip: "HangUp",
          active: false,
          showed: true,
          enabledState: true,
          realSize: 52,
          className: "buttonHangUpCall",
          action: () => this.actionHangUp(),
          showAt: 100000000000
        },
        {
          idButton: "moreOptions",
          image: moreOptions,
          tooltip: "More",
          active: false,
          enabledState: true,
          realSize: 52,
          className: "buttonBigCall",
          action: () => this.showMoreOptions(),
          showAt: 600
        }
      ]
    };
    this.timerTime = {};
    this.volume = 0;
    this.iDigit = null;
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
    this.sizeBarWidht = 438;
    this.sizeBarRightWidht = 52;
    this.integrationAction = null;
    this.integrationData = null;
    this.language = new Singleton();
    this.ivrPermission = this.sharedData.getGeneralPermissions()[117];
    this.audio = new Audio(XFerToneB);
    this.closeWindowActions = {
      [DRAGGABLE_WINDOWS.TRANSFER_CALL]: () => this.selectObject("transfer", false),
      [DRAGGABLE_WINDOWS.DTMF_TONES]: () => this.selectObject("dtmf", false),
      [DRAGGABLE_WINDOWS.MARK_CALL]: () => this.selectObject("marks", false),
      [DRAGGABLE_WINDOWS.ONGOING_CALL_IVR]: () => this.selectObject("ivr", false)
    }
    this.disabledButtonsState = { 
      [USER_STATE.OTHER]: { "disposition": false, "transfer": false, "dtmf": false, "volume": true, "mute": true, "hold": false, "marks": false, "ivr": false, "record": false },
      [USER_STATE.OTHER_PREVIEW]: { "disposition": false, "transfer": false, "dtmf": false, "volume": true, "mute": true, "hold": false, "marks": false, "ivr": false, "record": false },
      ["OTHERTEMP"]: { "disposition": true, "transfer": false, "dtmf": true, "volume": true, "mute": true, "hold": true, "marks": true, "ivr": true, "record": true },
    }
    this.problemInManualCall = this.sharedData.problemInManualCall;
    this.resize = this.resize.bind(this);
    this.isInCall=true;
  }
  resize() {
    let barButtons = this.refs["BarButtons"];
    if (barButtons) {
      let barSize = barButtons.offsetWidth;
      this.sizeBarWidht = this.state.renderButtons.reduce((sum, cur) => sum + (cur.hideAt < barSize ? cur.realSize : 0), 0);
      this.sizeBarRightWidht = this.state.rightButtons.reduce((sum, cur) => sum + (cur.showAt > barSize ? cur.realSize : 0), 0);
      var rightMargin = (barButtons.offsetWidth - this.sizeBarWidht - (this.sizeBarRightWidht * 2)) / 2.0;
      rightMargin = Math.min(70, rightMargin);
      rightMargin = Math.max(0, rightMargin);
      var leftMargin = rightMargin + this.sizeBarRightWidht;
      leftMargin = Math.min(leftMargin, 0);
      leftMargin = Math.max(leftMargin, 0);
      this.setState({
        barSize: barSize,
        marginRight: rightMargin,
        marginLeft: leftMargin
      });
    }
  }
  componentDidUpdate(){
    if(!this.state.setShowDataBySetting && this.props.showDataBySetting && this.props.extraDataCall.AgentXfer)
    {
      this.checkButtons("OTHERTEMP");
      this.setState({setShowDataBySetting:this.props.showDataBySetting});
    }
  }
  componentDidMount() {
    window.addEventListener("resize", this.resize);
    this.checkButtons(this.state.currentState);
    this.resize();
    this.getCallIcon();
    this.getRecordingStateButton();
    this.getListDispositions();
    this.audio.play();
  }
  componentWillUnmount() {
    this.isInCall=false;
    setTimeout(this.props.hideModal, 200);
    window.removeEventListener('resize', this.resize);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.onCloseWindow && this.closeWindowActions[nextProps.onCloseWindow]) {
      this.closeWindowActions[nextProps.onCloseWindow]();
    }
    if (this.state.dataCall.CallId && nextProps.dataCall && nextProps.dataCall.CallId && nextProps.dataCall.CallId > 0 
      && this.state.dataCall.CallId !== nextProps.dataCall.CallId && this.state.displayHeader) {           
      this.setState({ dataCall: nextProps.dataCall, extraDataCall: nextProps.extraDataCall });      
      this.getCallIcon();
      this.getRecordingStateButton();
      this.getListDispositions();
    }
    if (nextProps.dataCall.holdCall && !this.isActiveButton("hold")) {
      this.setVisibleItem("hold", nextProps.dataCall.holdCall);
    }
    if (nextProps.extraDataCall.HoldCall && !this.isActiveButton("hold") && this.state.currentState === USER_STATE.OTHER) {
      this.setVisibleItem("hold", nextProps.extraDataCall.HoldCall);
    }
    if (this.state.currentState !== nextProps.currentState) {
      this.checkButtons(nextProps.currentState);
      if (nextProps.currentState === USER_STATE.WRAPUP) {
        setTimeout(this.props.hideModal, 200);
        if (this.state.volumeMicrophone === 0) {
            Logger.Info("[callspace][componentWillReceiveProps] volumeMicrophone:", this.state.lastVolume);  
          this.props.volumeMicrophone(this.state.lastVolume);
        }
      }
    }
    switch (nextProps.assistedTransfer.currentState) {
      case ASSISTED_TRANSFER.TRANSFERRING:
        this.setState({ onTransferWindow: true });
        break;
      case ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
        this.setState({ onTransferWindow: false });
        break;
      case ASSISTED_TRANSFER.IDDLE_END:
        let integrationMessage = { client: "galatea", data: nextProps.extraDataCall.IvrPressed, action: "OngoingCallIvr", subaction: "onIdleEnd" };
        SingletonWebSocket.send(integrationMessage);
        this.props.hideModal();
        break;
      default:
        break;
    }
    if (nextProps.messagesIntegrations.dataMessageIntegration) {
      switch (nextProps.messagesIntegrations.dataMessageIntegration.action) {
        case INTEGRATION.ASSISTED_DIAL_ACD:
          this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration);
          break;
        case INTEGRATION.ASSISTED_DIAL_AGENT:
          this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration)
          break;
        case INTEGRATION.ASSISTED_DIAL_NUMBER:
          this.assistedTransfer(nextProps.messagesIntegrations.dataMessageIntegration);
          break;
        case INTEGRATION.CALL_ACTION:
          this.callbarActionFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration);
          break;
        case INTEGRATION.DISPOSITION:
        case INTEGRATION.SAVE_DISPOSITION:
          this.integrationAction=nextProps.messagesIntegrations.dataMessageIntegration.action;
          this.openFromIntegration("Disposition");
          break;
        case INTEGRATION.GET_ACD_DISPOSITIONS:
        case INTEGRATION.GET_CAMPAIGN_DISPOSITIONS:
        case INTEGRATION.GET_DISPOSITIONS:
          this.integrationAction = nextProps.messagesIntegrations.dataMessageIntegration.action;
          this.openFromIntegration("Disposition");
          break;
        case INTEGRATION.GET_TRANSFER_DATA:
          this.openFromIntegration("Transfer");
          break;
        case INTEGRATION.OPEN_WINDOW:
          this.openFromIntegration(nextProps.messagesIntegrations.dataMessageIntegration.window);
          break;
        default:
          break;
      }
    }
  }

  assistedTransfer(messageIntegration) {
    if (!this.isActiveButton("transfer")) {
      this.actionTransfer(messageIntegration);
    }
  }

  callbarActionFromIntegration(message) {
    let _this = this;
    switch (message.callAction) {
      case ASSISTED_TRANSFER.SECOND_CALL_HANG_UP:
        this.setState({ onTransferWindow: false });
        break;
      case INTEGRATION.DTMF:
        _this.iDigit = message.digit;
        if (!this.isActiveButton("dtmf")) {
          this.actionDTMF();
        }
        break;
      case INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS:
        if (!this.isActiveButton("disposition")) {
          this.integrationAction = INTEGRATION.GET_DISPOSITIONS_AND_NUMBERS;
          this.actionDisposition();
        }
        break;
      case INTEGRATION.GET_IVR_LIST:
        if (Boolean(parseInt(this.ivrPermission, 10)) && !this.isActiveButton("ivr")) {
          let props = { action: INTEGRATION.GET_IVR_LIST }
          this.actionIVR(props);
        }
        break;
      case INTEGRATION.HANG_UP:
        setTimeout(() => { this.actionHangUp(); }, 500);
        break;
      case INTEGRATION.HANG_UP_AND_LEAVE_MESSAGE:
        this.actionHangUpAndLeaveMessage();
        break;
      case INTEGRATION.HOLD:
        this.actionPauseCall();
        break;
      case INTEGRATION.IDLE_START:
        _this.integrationData = message.IVRId;
        if (!this.isActiveButton("ivr")) {
          let props = {
            action: INTEGRATION.IDLE_START,
            IVRId: this.integrationData
          }
          this.actionIVR(props);
        }
        break;
      case INTEGRATION.MARK_ADD:
        let props = null;
        const arrayMarks = this.sharedData.getCurrentCallMarks();
        if (!this.isActiveButton("marks")) {
          if (arrayMarks.length !== 0) {
            props = { action: INTEGRATION.MARK_ADD }
          }
          this.actionMarkCall(props);
        }
        break;
      case INTEGRATION.MUTE:
        this.actionMute();
        break;
      case INTEGRATION.GET_PHONE_NUMBERS:
        if (!this.isActiveButton("disposition")) {
          this.integrationAction = INTEGRATION.GET_PHONE_NUMBERS;
          this.actionDisposition();
        }
        break;
      case INTEGRATION.RECORDING_STOP_START:
        this.actionPauseRecord();
        break;
      case INTEGRATION.SET_VOLUME:
        if (!this.isActiveButton("volume")) {
          this.actionVolume();
        }
        break;
      default:
        break;
    }
  }
  openFromIntegration(window) {
    switch (window) {
      case "Transfer":
        if (!this.isActiveButton("transfer")) {
          this.actionTransfer();
        }
        break;
      case "Disposition":
        if (!this.isActiveButton("disposition")) {
          this.actionDisposition();
        }
        break;
      default: break;
    };
  }
  checkButtons(state) {
    var renderArray = this.state.renderButtons;
    if (this.disabledButtonsState[state] ){

      let objectDisabled = this.disabledButtonsState[state];
     
      if(this.sharedData.getDataPreviewPro().dialingMode === 1) {
        objectDisabled = this.disabledButtonsState[USER_STATE.OTHER_PREVIEW];
      }
      for (let obj in renderArray) {
        renderArray[obj].enabledState = objectDisabled[renderArray[obj].idButton];
      }
    } else {
      for (let obj in renderArray) {
        renderArray[obj].enabledState = true;
      }
    }

    renderArray = this.validateMarksPermission(renderArray);
    if(Object.values(USER_STATE).includes(state))
    {
      this.setState({ renderButtons: renderArray, currentState: state });
    }
  }

  validateMarksPermission(renderButtonsArray) {
    let markPermissionValue = this.sharedData.getAllowMarksPermission();

    let newArray = renderButtonsArray;

    for(let arr in newArray){
      if(newArray[arr].idButton === "marks"){
        newArray[arr].className = markPermissionValue ? newArray[arr].className : 'buttonDisabled';
        newArray[arr].action = markPermissionValue ? newArray[arr].action : null;
      }
    }

    return newArray;
  }

  getCallIcon() {
    if (this.state.dataCall) {
      let _this = this;
      let callIcon=this.sharedData.getCallIcon();
      if (callIcon) {
        _this.showExtraButtons(callIcon);
      }else{
        let objectData = {
          UserId: this.sharedData.getParameters().UserID,
          Id: this.state.dataCall.Id ? this.state.dataCall.Id : this.state.extraDataCall.Id,
          CallType: this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType,
          CallOutId: this.state.dataCall.CallOutId ? this.state.dataCall.CallOutId : this.state.extraDataCall.CallOutId,
          Phone: this.state.dataCall.Phone ? this.state.dataCall.Phone : this.state.extraDataCall.Phone
        };
        let objectResponseCallIcon = this.apiCont.getObjectResponse();
        Logger.Trace("apiCont.callIcon request");
        this.apiCont.callIcon(objectData, objectResponseCallIcon);
        objectResponseCallIcon.onError = (err) => {
          Logger.Warn("apiCont.callIcon objectData:", objectData, "error:", err);
          _this.setState({ iconCall: null });
        };
        objectResponseCallIcon.onSuccess = function (objResponse) {
          Logger.Trace("apiCont.callIcon onSucces:", objResponse);
          _this.showExtraButtons(objResponse);
        };
      }
    }
  }
  getRecordingStateButton() {
    let _this = this;
    let objectResponseRecordCall = this.apiCont.getObjectResponse();
			Logger.Trace('apiCont.RecordCall request');
      let objectDataRecord = {
        campId: this.state.dataCall.Id ? this.state.dataCall.Id : this.state.extraDataCall.Id,
        option: this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType,
      };
			this.apiCont.GetRecordCallPermission(objectDataRecord, objectResponseRecordCall);
			objectResponseRecordCall.onError = err => {
				Logger.Warn('apiCont.RecordCall objectData:', objectDataRecord, 'error:', err);
			};
			objectResponseRecordCall.onSuccess = function (objResponse) {
				Logger.Trace('apiCont.RecordCall onSucces:', objResponse);
        _this.setVisibleItem("marks", objResponse !== 3);
				if (objResponse === 4) {
          _this.actionPauseRecord(true)
        }
			};
  }

  showExtraButtons(callIcon){
    let _this = this;
    this.setState({ iconCall: callIcon });
    if (callIcon.LeaveRecMessage === 1) {
      let btns = _this.state.renderButtons;
      btns.forEach(element => {
        if (element.idButton === "leaveMessage") {
          element.showed = true;
          return;
        }
      });
      _this.setState({ renderButtons: btns });
    }
    _this.setVisibleItem("disposition", callIcon.ShowDisposition);
    _this.setVisibleItem("record", callIcon.IsStartStopRecording);
    _this.setVisibleItem("ivr", Boolean(parseInt(_this.ivrPermission, 10)));
    _this.setState({ recording: callIcon.IsStartStopRecording });
  }
  getListDispositions(){
        let dataSend;
        let _this = this;
        let objectResponse = this.apiCont.getObjectResponse();
        let timeout = this.sharedData.getRequestTimeout();
        Logger.Debug("[CallSpace] disposition list request timeout:"+timeout);
        if(this.props.preview.isSetPreviewRecord && this.sharedData.getDataPreviewPro().dialingMode === 1)
        {
          dataSend= {
            CallOutId: this.props.preview.callOutId ,
            Id: this.props.preview.camId,
            Type: 1,
            UserId: this.sharedData.getParameters().UserID,
            CamId: this.props.preview.camId
          };
        }else if (this.state.dataCall) {
          dataSend= {
            CallOutId: this.state.dataCall.CallOutId,
            Id: this.state.dataCall.Id,
            Type: (this.state.dataCall.CallType - 1),
            UserId: this.sharedData.getParameters().UserID,
            CamId: this.state.dataCall.Id
          };
        }
        if(Object.keys(this.props.extraDataCall).length > 0 && this.state.currentState === USER_STATE.OTHER && this.sharedData.getDataPreviewPro().dialingMode === 0)
        {
          dataSend= {
            CallOutId: this.props.extraDataCall.CallOutId,            
            Id: this.props.extraDataCall.CamId,
            Type: this.props.extraDataCall.CallType === 2 ? 1 : 0,
            UserId: this.sharedData.getParameters().UserID,
            CamId: this.props.extraDataCall.CamId
          };
        }
        Logger.Debug("[CallSpace] disposition list request CallOutId:"+dataSend.CallOutId+" CamId:"+dataSend.CamId+" Id:"+dataSend.Id+" Type:"+dataSend.Type+" UserId:"+dataSend.UserId );
        this.apiCont.dispositionList(dataSend, objectResponse, timeout);
        objectResponse.onError = function (messageError) {
            Logger.Warning("error consulting dispositionList in data base----->>", messageError);
            _this.setState({ dispositionListError: messageError });
        };
        objectResponse.onCatch = function (messageError){
            Logger.Warning("catch error consulting dispositionList in data base----->>", messageError);
        };
        objectResponse.onSuccess = function (objResponse) {
            Logger.Trace("[RateCall] API Response OK ");
            _this.setState({ dispositionListInformation: objResponse });
        }
  }

  showMoreOptions() {
    this.selectObjectRight("moreOptions", !this.isActiveButton("moreOptions", this.state.rightButtons))
    this.setState({ showingMoreOptions: !this.state.showingMoreOptions });
  }
  moreOptionsContainer(item) {
    return <div className="moreOptionsContainer" key={"buttonMoreOptions"}>
      <div className={item.className} onClick={item.action}> {item.image} </div>
      {item.active && this.isActiveButton("moreOptions", this.state.rightButtons) && this.state.currentState !== USER_STATE.WRAPUP &&
        <div className="barButtonsFloatCall">
          {this.state.renderButtons.map((item, i) => (item.showed && item.hideAt > this.state.barSize) &&
            <div className={item.className} key={"button" + i} onClick={item.action}> {item.image} </div>)}
        </div>}
    </div>
  }

  classNameHeader() {
    if (this.isActiveButton("disposition")) {
      return TYPE_DESIGN_CALL.WRAPUP;
    }

    return this.state.dataCall.CallType ?
      (this.state.dataCall.CallType === TYPE_CALL.INBOUND ? TYPE_DESIGN_CALL.INBOUND : TYPE_DESIGN_CALL.OUTBOUND) :
      (this.state.extraDataCall.CallType === TYPE_CALL.INBOUND ? TYPE_DESIGN_CALL.INBOUND : TYPE_DESIGN_CALL.OUTBOUND);
  }
  setVisibleItem(idSeleccion, visible) {
    let renderButtons = this.state.renderButtons;
    let index = -1;
    for (var i = 0; i < renderButtons.length; ++i) {
      if (renderButtons[i].idButton === idSeleccion) {
        index = i;
        break;
      }
    }
    renderButtons[index].showed = visible;
    this.setState({ renderButtons: renderButtons });
  }
  isActiveButton(idSeleccion, arraySearch = this.state.renderButtons) {
    let index = -1;
    for (var i = 0; i < arraySearch.length; ++i) {
      if (arraySearch[i].idButton === idSeleccion) {
        index = i;
        break;
      }
    }
    return arraySearch[index].active;
  }
  selectObjectRight(idSeleccion) {
    let rightButtons = this.state.rightButtons;
    let index = -1;
    for (var i = 0; i < rightButtons.length; ++i) {
      if (rightButtons[i].idButton === idSeleccion) {
        index = i;
        break;
      }
    }

    if (rightButtons[index].active) {
      rightButtons[index].className = rightButtons[index].className.replace(" selectedMoreOption", "");
    } else {
      rightButtons[index].className += " selectedMoreOption";
    }
    rightButtons[index].active = !rightButtons[index].active;
    this.setState({ rightButtons: rightButtons });
  }
  selectObject(idSeleccion, active) {
    let renderButtons = this.state.renderButtons;
    let index = -1;
    for (var i = 0; i < renderButtons.length; ++i) {
      if (renderButtons[i].idButton === idSeleccion) {
        index = i;
        break;
      }
    }

    if (active) {
      renderButtons[index].className += " selected";
    } else {
      renderButtons[index].className = renderButtons[index].className.replace(" selected", "");
    }
    renderButtons[index].active = active;
    this.setState({ renderButtons: renderButtons });
  }
  actionDisposition() {
    this.selectObject("disposition", !this.isActiveButton("disposition"));
  }
  actionTransfer(messageIntegration = "") {
    (!this.state.onTransferWindow && this.selectObject("transfer", !this.isActiveButton("transfer")));
    this.props.insertWindow(transferCallWindow({ dataCall: this.state.dataCall, messageIntegration: messageIntegration }), (this.state.onTransferWindow ? false : true));
  }
  actionDTMF() {
    this.selectObject("dtmf", !this.isActiveButton("dtmf"));
    let isEdit = this.state.iconCall ? this.state.iconCall.IsEditDtmf : false;
    let dtmfOptions = this.state.iconCall ? this.state.iconCall.DtmfOptions : [];
    let dtmfWindow = dtmfTonesWindow({ isEditDtmf: isEdit, dtmfOptions: dtmfOptions, digit: this.iDigit });
    this.props.insertWindow(dtmfWindow, true);
    this.iDigit = null;
  }
  actionVolume() {
    this.selectObject("volume", !this.isActiveButton("volume"));
  }
  actionMute() {
    let mutedCall = !this.isActiveButton("mute");
    this.selectObject("mute", mutedCall);
    this.props.callAction(ACTION_CALL_ACD.MUTE, mutedCall);

    let prevVolume = mutedCall ? this.state.volumeMicrophone : this.state.lastVolume;
    let newVolumne = mutedCall ? 0 : this.state.lastVolume;

    this.setState({
      lastVolume: prevVolume,
      volumeMicrophone: newVolumne
    });
    Logger.Info("[callspace][actionMute] volumeMicrophone:", newVolumne);
    Logger.Info("[callspace][actionMute] volumeSpeaker:", this.sharedData.getVolumeSpeaker());
    this.props.volumeMicrophone(newVolumne);
    this.props.volumeSpeaker(this.sharedData.getVolumeSpeaker());
    let integrationMessage = { client: "galatea", action: "onCallBar" , subaction: "onMute", data:mutedCall};
    SingletonWebSocket.send(integrationMessage);
  }
  actionPauseCall() {
    let holdCall=!this.isActiveButton("hold");
    this.selectObject("hold", holdCall);
    if(this.state.currentState === USER_STATE.OTHER)
    {
      this.props.callAction(ACTION_CALL_ACD.HOLD,{},this.state.extraDataCall.CallOutId);
    }
    else{
      this.props.callAction(ACTION_CALL_ACD.HOLD);

    }
    
    let integrationMessage = { client: "galatea", action: "onCallBar" , subaction: "onHold", data:holdCall};
    SingletonWebSocket.send(integrationMessage);
  }
  actionMarkCall(props = null) {
    this.selectObject("marks", !this.isActiveButton("marks"));
    this.props.insertWindow(markCallWindow(props), true);
  }
  actionIVR(props = null) {
    this.selectObject("ivr", !this.isActiveButton("ivr"));
    this.props.insertWindow(ongoingCallIvrWindow(props), true);
  }
  actionPauseRecord() {
    this.props.messageToStateMachine(
      messageStartStopRecording(!this.isActiveButton("record"))
    );
    this.selectObject("record", !this.isActiveButton("record"));
  }
  actionHangUp() {
    this.props.preview.isSetPreviewRecord && this.acionHangUpPreview();
    this.setState({disableHp: true });
    setTimeout(()=>{
      this.setState({disableHp: false });
    },3000);
    let callOutId = this.sharedData.getDataPreviewPro().dialingMode === 1 ? this.state.extraDataCall.CallOutId : 0;
    this.props.messageToStateMachine(messageHangUp(HANG_UP_SUBACTIONS.CALL,callOutId));
    this.sharedData.setCurrentCallMarks([]);
    this.sharedData.setCallIcon(null);
  }
  acionHangUpPreview()
  {
    this.props.updatePreviewRecord({IsSave: false,  action: 'UPDATE_DATA_CALL'});
  }
  actionHangUpAndLeaveMessage() {
    this.props.messageToStateMachine(messageHangUp(HANG_UP_SUBACTIONS.LEAVE_MESSAGE,0));
  }
  setVolumeSpeaker(vol) {
    Logger.Info("[callspace][setVolumeSpeaker] vol:", vol);
    this.sharedData.setVolumeSpeaker(vol);
    this.setState({ volumeSpeaker: vol });
    let renderButtons = this.state.renderButtons;
    let index = -1;
    for (var i = 0; i < renderButtons.length; ++i) {
      if (renderButtons[i].idButton === "volume") {
        index = i;
        break;
      }
    }
    renderButtons[index].image = (vol === 0 ? noVolume : vol < 60 ? volumeMedium : volume);
    this.setState({ renderButtons: renderButtons });
  }
  setVolumeMicrophone(volume) {
    Logger.Info("[callspace][setVolumeMicrophone] vol:", volume);
    this.sharedData.setVolumeMic(volume);
    this.setState({ volumeMicrophone: volume, lastVolume: volume });
    this.selectObject("mute", volume === 0);
  }
  volumeContainer(item) {
    return <div className="volumeContainer" key={"buttonVolume"}>
      <OverlayTrigger
        id={`tlt-buttonsContainer-volumme`}
        key={`tlt-buttonsContainer-volumme`}
        placement="top"
        overlay={
          <Tooltip className="buttonsContainer-tooltip top show" id={`toolTiptlt-buttonsContainer-volumme`}>
            {this.language.getText(`GUICallSpace${item.tooltip}`)}
          </Tooltip>
        }
      >
        <div className={item.className} onClick={item.action}>
          {item.image}
        </div>
      </OverlayTrigger>
      {item.active && (
        <VolumeWindow
          volSpeaker={this.state.volumeSpeaker}
          volMicrophone={this.state.volumeMicrophone}
          muteMicrophone={this.state.volumeMicrophone === 0}
          onChangeVolumeSpeakers={vol => this.setVolumeSpeaker(vol)}
          onChangeVolumeMicro={volume => this.setVolumeMicrophone(volume)}
          alert={e => this.props.alertVolume(e)}
          closeItem={()=>this.selectObject("volume", false)}
        />
      )}
    </div>
  }

  fillDataCells() {
    if (this.state.dataCall && this.state.dataCall.DataContact && this.state.dataCall.DataContact.length !== 0) {
      let array = [];
      for (let i = 0; i < 5; ++i) {
        array.push({ text: this.state.dataCall.DataContact[i], focus: false, index: i });
      }
      return (array);
    }
    else if (this.state.extraDataCall && this.state.extraDataCall.ContactData && this.state.extraDataCall.ContactData.length !== 0) {
      let array = [];
      for (let i = 0; i < 5; ++i) {
        array.push({ text: this.state.extraDataCall.ContactData[i], focus: false, index: i });
      }
      return (array);
    }
    else {
      let array = [];
      for (let i = 0; i < 5; ++i) {
        array.push({ text: "", focus: false, index: i });
      }
      return (array);
    }
  }
  resetIntegrationAction() {
    this.integrationAction = null;
  }
  saveDataCall(dataCall) {
    this.setState({ dataCall: dataCall });
  }

  render() {
    const telephoneNumber = this.state.dataCall.Phone ? this.state.dataCall.Phone : this.state.extraDataCall.Phone;
    const type = this.state.dataCall.CallType ? this.state.dataCall.CallType : this.state.extraDataCall.CallType;
    const showHeader = (this.sharedData.getDataPreviewPro().dialingMode === 0 && this.state.currentState !== USER_STATE.ASSISTED) || (this.sharedData.getDataPreviewPro().dialingMode === 1 && (this.state.currentState === USER_STATE.DIALOG || this.state.currentState ===  USER_STATE.OTHER));
    const showHeaderPreview = (this.sharedData.getDataPreviewPro().dialingMode === 1 && this.props.preview.dialogTime !== undefined  && this.state.currentState === USER_STATE.WRAPUP);
    return (
      <div className="callSpace">
        {showHeader  &&
        <CallHeader campaignName={this.state.iconCall ? this.state.iconCall.Description : ""}
          phoneNumber={telephoneNumber}
          typeCall={type}
          typeHeader={this.classNameHeader()}
          iconCallFrame={this.state.iconCall ? this.state.iconCall.Frame : -1}
          startTimer={!this.problemInManualCall && (this.state.currentState === USER_STATE.DIALOG || this.state.currentState === USER_STATE.OTHER)}
          recordingEnabled={this.state.recording}
          buttonRecordingActive={this.isActiveButton("record")}// ? this.isActiveButton("record") : true}
          dataCall={this.state.dataCall}
          currentState = {this.state.currentState}
          dataCallAssisted = {this.sharedData.getDataAssistedCall()}
        />
        }
        {showHeaderPreview &&
          <CallHeaderPreview
          campaignName={this.props.preview.campaignName ? this.props.preview.campaignName : (this.state.iconCall ? this.state.iconCall.Description : "")}
          iconCallFrame={this.props.preview.iconCampaing ? this.props.preview.iconCampaing : (this.state.iconCall ? this.state.iconCall.Frame : "") }
          callKey={this.props.preview.callKey}
          seconds={this.props.preview.dialogTime}
          phones={this.props.preview.phones}
          isRunning={false}
          userState={this.state.currentState}
          />
        } 
        {this.isActiveButton("disposition") || this.state.currentState === USER_STATE.WRAPUP ?
          <RateCall
            phoneNumber={this.state.dataCall ? this.state.dataCall.Phone : ""}
            onDispositionButton={() => this.selectObject("disposition", false)}
            dataCall={this.props.userState.currentState === USER_STATE.OTHER ? this.state.extraDataCall : this.state.dataCall}
            editableCallKey={this.state.iconCall ? this.state.iconCall.EditableCallKey : false}
            userState={this.state.currentState}
            dispositionTime={this.state.dataCall.WrapUpTime}
            messagesIntegrations={this.props.messagesIntegrations}
            integrationAction={this.integrationAction}
            resetIntegrationAction={()=>{this.resetIntegrationAction()}}
            problemInManualCall={this.problemInManualCall}
            dispositionListInformation={this.state.dispositionListInformation}
            dispositionListError={this.state.dispositionListError}
            actionPrevRecord={this.props.actionPrevRecord}
          /> :
          <CallWindow typeCall={this.state.dataCall ? this.state.dataCall.CallType === TYPE_CALL.INBOUND ? TYPE_DESIGN_CALL.INBOUND : TYPE_DESIGN_CALL.OUTBOUND : TYPE_DESIGN_CALL.INBOUND}
            editableCallKey={this.state.iconCall ? this.state.iconCall.EditableCallKey : false}
            dataCall={this.state.dataCall}
            iconCall={this.state.iconCall }
            extraDataCall={this.state.extraDataCall}
            dataCells={this.fillDataCells()}
            saveDataCall={this.saveDataCall.bind(this)}
          />}
        {(this.state.currentState === USER_STATE.DIALOG || (this.state.currentState === USER_STATE.OTHER )) && (
          <div className="barButtonsCall" ref="BarButtons">
            <div className="buttonsContainer" style={{ width: this.sizeBarWidht, marginRight: this.state.marginRight, marginLeft: this.state.marginLeft }}>
              {this.state.renderButtons.map(
                (item, i) =>
                  item.showed &&
                  item.enabledState &&
                  item.hideAt <= this.state.barSize &&
                  (item.idButton === "volume" ? (
                    this.volumeContainer(item)
                  ) : (
                    
                      <OverlayTrigger
                        key={`tlt-buttonsContainer-${i}`}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltIpId-tlt-buttonsContainer-${i}`} className="buttonsContainer-tooltip top show">
                            {this.language.getText(`GUICallSpace${item.tooltip}`)}
                          </Tooltip>
                        }
                      >
                        <div className={item.className} key={"button" + i} onClick={item.action}>
                          {item.image}
                        </div>
                      </OverlayTrigger>
                    ))
              )}
            </div>
            <div className="rightButtons" style={{ width: this.sizeBarRightWidht }}>
              {this.state.rightButtons.map(
                (item, i) =>
                  item.showAt >= this.state.barSize &&
                  item.enabledState &&
                  (item.idButton === "volume" ? 
                  (this.volumeContainer(item)) 
                  : 
                  (
                    <div
                        className={item.className}
                        key={"button" + i}
                        onClick={item.action}>
                        {item.image}
                    </div>
                    )) &&
                  (item.idButton === "moreOptions" ? 
                  (this.moreOptionsContainer(item)) 
                  : 
                  (
                      <OverlayTrigger
                        key={`tlt-buttonsContainer-hangup`}
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltIpId-tlt-buttonsContainer-hangup`} className="buttonsContainer-tooltip top show">
                            {this.language.getText(`GUICallSpaceHangUp`)}
                          </Tooltip>
                        }>
                        <div
                          className={item.className+` ${item.idButton==="hangUp" && this.state.disableHp && "disabled"}`}
                          key={"button" + i}
                          onClick={item.idButton==="hangUp" && this.state.disableHp? ()=>{}: item.action}
                          id={"cs-tooltip-hangUp"}>
                          {item.image}
                        </div>
                      </OverlayTrigger>                
                    )
                  )
              )}
            </div>
          </div>
        )}
      </div>
    );
    }
  }


function mapStateToProps(state) {
  return {
    assistedTransfer: state.assistedTransfer,
    messagesIntegrations: state.messagesIntegrations,
    preview: state.preview,
    showDataBySetting: state.transferReducer.showDataBySetting,
		userState: state.userState,
  }
}
function mapDispatchToProps(dispatch) {
  const { hideModal } = ModalActions.creators;
  return ({
    messageToStateMachine: (message) => { dispatch(messageToStateMachine(message)); },
    callAction: (actionType, parameters, callOutId) => { dispatch(callAction(actionType, parameters, callOutId)); },
    insertWindow: (dragWindow, closeComponentIfOpen) => { dispatch(insertWindow(dragWindow, closeComponentIfOpen)); },
    removeWindow: (iDdragComponent) => { dispatch(removeWindow(iDdragComponent)); },
    hideModal: () => { dispatch(hideModal()); },
    volumeMicrophone: (volume) => { dispatch(volumeMicrophone(volume)) },
    volumeSpeaker: (volume) => { dispatch(volumeSpeaker(volume)) },
    updatePreviewRecord: (record) => {dispatch(updatePreviewRecord(record));
    },
  });
}
export default CallSpace = connect(
  mapStateToProps,
  mapDispatchToProps
)(CallSpace);



// WEBPACK FOOTER //
// ./src/components/workSpace/callSpace.jsx